function asyncTimeout(timeout) {
  return new Promise((resolve) => setTimeout(resolve, timeout));
}

export { asyncTimeout };
//# sourceMappingURL=async-timeout.js.map
